<div class="button" >
  <a role="button" class="{{class}}" [class.rounded]="rounded" (click)="onClick($event)">
    <co-image [width]="iconWidth" [class]="'icon-padding'" [height]="iconHeight" type="svg" [key]="icon" [imageSet]="imageSet"></co-image>
  </a>
</div>